'use client';

import {
  cn,
  Input as CoreInput,
  InputProps as CoreInputProps,
  Label,
  Span,
  VariantProps,
} from '@scatterlab/zeta-core';
import { ComponentType, memo, SVGProps, useId, useState } from 'react';

import IconButton from './button/IconButton';
import { Delete16Icon } from './icons';
import { textField } from './styles';

export type InputProps = CoreInputProps &
  VariantProps<typeof textField> & {
    leadingChar?: string;
    RightIcon?: ComponentType<SVGProps<SVGSVGElement>>;
    inputClassName?: string;
    clearButton?: boolean;
  };

const Input = ({
  className,
  RightIcon,
  id: idAsProp,
  leadingChar,
  onFocus,
  onBlur,
  inputClassName,
  clearButton,
  onContentSizeChange,
  ...props
}: InputProps) => {
  const id = useId();
  const [focus, setFocus] = useState(false);

  return (
    <Label
      htmlFor={idAsProp || id}
      className={cn(textField({ focus }), className)}
    >
      {leadingChar && (
        <Span className="native:left-3 absolute text-white/50">
          {leadingChar}
        </Span>
      )}
      <CoreInput
        id={idAsProp || id}
        className={cn(
          'body14 flex min-w-0 flex-1 bg-transparent p-0 text-white outline-none number-appearance-none placeholder:text-white/50',
          leadingChar && 'pl-[1rem]',
          inputClassName,
        )}
        autoComplete="off"
        onFocus={(e) => {
          setFocus(true);
          onFocus?.(e);
        }}
        onBlur={(e) => {
          setFocus(false);
          onBlur?.(e);
        }}
        {...props}
      />
      {RightIcon && <RightIcon className="size-4 text-white" />}
      {clearButton && (
        <IconButton
          icon={Delete16Icon}
          className="size-4 rounded-full bg-gray-800 backdrop-blur-16"
          iconClassName="size-[8.6px] text-gray-100"
          onPress={() => props.onChangeText?.('')}
          hitSlop={8}
        />
      )}
    </Label>
  );
};
export default memo(Input);
